import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { compose } from 'recompose';
import { Button, Divider, Form, Grid, Message, Rating, Segment } from 'semantic-ui-react';
import { getReviews, setReview, updateInfluencerDetails } from './utils';
import AvatarProfile from '../../components/avatar';

import { authService } from '../../utils/auth-service';
import hasUserInfo from '../../hocs/has-user-info';

class InfluencerReviews extends Component {
  static propTypes = {
    influencer: PropTypes.object.isRequired,
    influencerDetails: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: '',
      success: '',
      reviews: [],
      rating: 0,
      content: '',
    };
  }

  componentDidMount() {
    this.setState({ success: '' });
    this.loadReviews();
  }

  onSubmitReview = event => {
    event.preventDefault();
    const { rating, content } = this.state;
    const { influencer, userInfo } = this.props;
    const { organisationId } = userInfo;

    const data = {
      rating,
      content,
      organisation: organisationId,
      influencer: influencer.id,
      user: authService.uid(),
    };

    return setReview(data)
      .then(response => updateInfluencerDetails(this.props.influencerDetails.id, response))
      .then(() => {
        this.setState({
          rating: 0,
          content: '',
          error: '',
          success: 'Your review has been successfully posted.',
        });
        return this.loadReviews();
      })
      .catch(() =>
        this.setState({ error: 'There was an error posting your review.', success: '' }),
      );
  };

  loadReviews = () => {
    const { influencer, userInfo } = this.props;
    const { organisationId } = userInfo;
    getReviews(influencer.id, organisationId)
      .then(reviews => {
        const reviewArray = [];
        _.forEach(reviews, review => {
          const formattedReview = review.toJSONTree();
          reviewArray.push(formattedReview);
        });

        return this.setState({
          loading: false,
          error: '',
          reviews: reviewArray.reverse(),
        });
      })
      .catch(() =>
        this.setState({
          loading: false,
          error: 'There was an error loading the reviews for this influencer.',
          reviews: [],
        }));
  }

  render() {
    const { error, success, reviews, rating, content } = this.state;

    return (
      <div className="page-content">
        <Grid>
          <Grid.Column width={9}>

            <Segment>
              <div className="spacer small" />
              { reviews.length > 0 &&
              <p><b>{reviews.length === 1 ? '1 review' : `${reviews.length} reviews`}</b></p>
              }
              { _.map(reviews, review => (
                <div key={review.id} className="simple-message">
                  <Divider />
                  <div className="spacer small" />
                  <div className="top">
                    <div className="avatar">
                      <AvatarProfile name={review.createdBy.name} size={36} plain />
                    </div>
                    <div className="user-info">
                      <p>
                        {review.createdBy.name}
                        &nbsp;&nbsp;
                        <span className="light">
                          {moment(review.createdDate).format('ddd D MMM hh:mm')}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="content-container">
                    <Rating icon="star" rating={review.rating} maxRating={5} disabled />
                    <div className="spacer small" />
                    <p>{review.content}</p>
                    <div className="spacer small" />
                  </div>
                </div>
              ))}
            </Segment>
          </Grid.Column>
          <Grid.Column width={7}>
            <Segment padded>
              <p className="light">Your notes and reviews are only available internally to your organisation</p>
              <Divider />
              <p><b>Rate this influencer <span className="light">(optional)</span></b></p>
              <div className="spacer small" />
              <Rating
                icon="star"
                rating={rating}
                maxRating={5}
                onRate={(e, v) => this.setState({ rating: v.rating })}
                size="large"
              />
              <div className="spacer small" />
              <Form onSubmit={this.onSubmitReview}>
                <Form.TextArea
                  placeholder="Tell us more"
                  onChange={(e, v) => this.setState({ content: v.value })}
                  value={content}
                  label="Your Comment"
                  required
                />
                <Button size="medium" fluid color="pink">Add Note or Review</Button>
              </Form>
              {error &&
              <Message negative>
                <p>{error}</p>
              </Message>}
              {success &&
              <Message positive>
                <p>{success}</p>
              </Message>}
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

InfluencerReviews.propTypes = {
  userInfo: PropTypes.object.isRequired,
};


export default compose(
  hasUserInfo,
)(InfluencerReviews);



/** WEBPACK FOOTER **
 ** ./src/components/influencer-reviews/index.js
 **/